<template>
  <div class="userContainer">
    <div class="userInfo">
      <div class="img"></div>
      <!-- <img src="" alt=""> -->
      <div class="userName">{{ userInfo.userName }}</div>
      <div class="userCode">学号：{{ userCode }}</div>
      <span>当前登录</span>
      <div class="belong">
        <div>{{ userInfo.specialtyName }}</div>
        <div>{{ userInfo.className }}</div>
      </div>
    </div>
    <div class="logout" @click="logout">退出账号</div>
    <back-to :path="'/'"></back-to>
  </div>
</template>
<script>
import api from "@/api";
import backTo from "@/components/back";
import { Dialog } from "vant";
export default {
  components: { backTo, [Dialog.name]: Dialog },
  data() {
    return {
      isLoading: false,
      userCode: "",
      userInfo: {}
    };
  },
  created() {
    this.userCode = localStorage.getItem("userCode");
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    logout() {
      Dialog.confirm({
        title: "退出",
        message: "确定退出登录吗？"
      })
        .then(() => {
          this.$get(api.userInfo.logout()).then(res => {
            if (res.status === 1) {
              localStorage.removeItem("x_token");
              localStorage.removeItem("userInfo");
              localStorage.removeItem("userCode");
              localStorage.removeItem("claimId");
              localStorage.removeItem("claimCode");
              localStorage.removeItem("claimName");
              this.$toast({
                message: "退出成功!",
                duration: 1000,
                position: "bottom"
              });
              location.href = location.origin + location.pathname + "#/login/";
            } else {
              this.$toast({
                message: res.message,
                duration: 1000,
                position: "bottom"
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.userContainer {
  background-color: #fff;
  padding: 50px 24px 0;
  .userInfo {
    position: relative;
    width: 100%;
    height: 330px;
    border-right: 40px;
    background: url("../../assets/gerenzhongxin.png") no-repeat;
    background-size: 100% 100%;
    padding: 50px 14px 40px 14px;
    .img {
      margin-left: 46px;
      width: 119px;
      height: 127px;
      float: left;
      background-image: url("../../assets/touxiang.png");
      background-size: 100% 100%;
    }
    .userName {
      font-size: 36px;
      font-family: PingFangSC;
      font-weight: 600;
      color: #fff;
      margin: 20px 0 10px 200px;
      letter-spacing: $letter-spacing;
    }
    .userCode {
      font-size: 22px;
      font-family: PingFangSC;
      font-weight: 400;
      color: #fff;
      letter-spacing: $letter-spacing;
      margin-left: 200px;
    }
    span {
      font-size: 22px;
      font-family: PingFangSC;
      font-weight: 500;
      color: #fff;
      position: absolute;
      top: 70px;
      right: 23px;
    }
    .belong {
      margin-top: 50px;
      display: flex;
      padding: 0 46px;
      div {
        flex: 1;
        height: 80px;
        background: #d0ffef;
        border-radius: 40px;
        line-height: 80px;
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        color: #0c4650;
        letter-spacing: $letter-spacing;
        @include text-ellipsis;
        padding: 0 20px;
        &:first-of-type {
          margin-right: 40px;
        }
      }
    }
  }
  .logout {
    margin-top: 80px;
    width: 100%;
    height: 100px;
    box-shadow: $box-shadow;
    line-height: 100px;
    text-align: center;
    border-radius: 50px;
    font-size: 30px;
    font-family: PingFangSC;
    font-weight: 500;
    color: $color-primary;
  }
}
</style>
